<div class="fleet-module-container-full py-4">


  <div class="loading-overlay" [class.loading-hidden]="!(store.loading$ | async)">
    <div class="loading-content">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem;">
      </i>
      <h4>Cargando información</h4>
      <p>Estamos obteniendo las ultimas validaciones...</p>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="(store.errorMessage$ | async) as error">

    <div class="loading-content">

      <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #db8d84;">
      </i>

      <h4>Ocurrió un error</h4>

      <p style="color: #666;">
        {{ error || 'No se pudo cargar la información' }}
      </p>

      <div style="
          display: flex;
          justify-content: center;
        ">

        <a href="/validation" style="
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            color: var(--gl-primary);
            text-decoration: none;
            font-weight: 500;
          ">

          <i class="pi pi-arrow-left"></i>
          Regresar
        </a>

      </div>
    </div>

  </div>

  <div class="content-wrapper" [class.loading]="store.loading$ | async">

    <ng-container *ngIf="fleetChecklist | async as checklist">
      <ng-container *ngIf="vehicleEditor.vehicles$ | async as vehicles">

        <app-validation-section-header [title]="checklist.name" showMainMenuButton="true">
          <div header-subtitle class="header-subtitle-container w-100 mt-2">
            <div class="header-metadata">
              <ng-container *ngIf="checklist.parameters?.validationDate">
                <div class="validation-date">
                  <i class="material-icons">event</i>
                  <span>{{ checklist.parameters.validationDate }}</span>
                </div>
              </ng-container>

              <div class="tags">
                <div class="tag" *ngFor="let tag of checklist.tags">
                  {{ tag }}
                </div>
              </div>

              <span class="checklist-status-badge status-{{ checklist.status | lowercase }}">
                {{
                checklist.status === 'pending' ? 'Pendiente' :
                checklist.status === 'completed' ? 'Completado' :
                checklist.status === 'sent' ? 'Enviado' :
                checklist.status
                }}
              </span>
            </div>

          </div>
        </app-validation-section-header>

        <div class="d-flex flex-row justify-content-between align-items-center mt-2" style="margin-bottom: 18px;">
          <div class="d-flex flex-row gap-2 w-100">
            <div class="search-container-clean shadow-sm" style="max-width: 400px;">
              <i class="material-icons search-icon-clean">search</i>
              <input class="text-input-clean" type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
                placeholder="Buscar unidad o placa...">
            </div>
            <ng-container *ngIf="checklist.status == 'pending'">
              <button class="btn-standar btn-auto-mark d-inline-flex align-items-center gap-1 shadow-sm" [ngClass]="{
                  'auto-marking-active': autoMarking,
                  'auto-marking-inactive': !autoMarking
                }" (click)="toggleAutoMarking()">
                <i class="material-icons align-middle" style="font-size: 1.5rem;" [class.spin]="autoMarking">

                  {{ autoMarking ? 'autorenew' : 'smart_toy' }}

                </i>
              </button>
            </ng-container>
          </div>
          <div class="d-flex flex-row gap-2 w-100 justify-content-end">
            <!-- Botón de Auto-Marcado Premium -->


            <ng-container *ngIf="checklist.status == 'pending'; else notPending">

              <!-- Guardar Validación -->
              <button
                class="btn-standar validation-save-btn"
                [class.validation-save-btn--modified]="isModified$ | async"
                (click)="onSaveValidation()">

                <i class="material-icons validation-save-btn__icon">
                  backup
                </i>

                <span class="validation-save-btn__text">
                  Guardar
                </span>

                <ng-container *ngIf="countdown$ | async as countdown">
                  <span
                    *ngIf="countdown > 0"
                    class="validation-save-btn__countdown">
                    {{ countdown }}s
                  </span>
                </ng-container>

              </button>

              <p-splitButton styleClass="custom-split-btn" label="Finalizar Validación" icon="pi pi-book"
                (onClick)="onFinishValidation()" [model]="editableOptions">
              </p-splitButton>

            </ng-container>

            <!-- ELSE -->
            <ng-template #notPending>
              <p-splitButton styleClass="custom-split-btn" label="Enviar a Validación" icon="pi pi-book"
                (onClick)="onSendValidation()" [model]="finalizedOptions">
              </p-splitButton>
            </ng-template>


          </div>
        </div>

        <app-vehicle-checklist-table></app-vehicle-checklist-table>
      </ng-container>
    </ng-container>
  </div>

</div>

<p-dialog [visible]="fleetEditor.editModalOpen$ | async" [modal]="true" [draggable]="false" [resizable]="false"
  appendTo="body" [showHeader]="false" [style]="{width: '50vw'}" [breakpoints]="{ '1600px': '75vw', '640px': '100vw' }">
  <app-fleet-checklist-edit-view (onUpdated)="onUpdated($event)"></app-fleet-checklist-edit-view>
</p-dialog>

<p-dialog [style]="{width: '40vw'}" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [visible]="vehicleEditor.uploadEvidenceModalOpen$ | async" [modal]="true" [draggable]="false" [resizable]="false"
  appendTo="body" [showHeader]="false">
  <app-checklist-evidence-upload-view [style]="{width: '50vw'}"></app-checklist-evidence-upload-view>
</p-dialog>
